'use client';

import * as React from 'react';

var AIStarListIcon = function () { return (React.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: 16, height: 16, viewBox: '0 0 16 16', fill: 'none' },
    React.createElement("g", { clipPath: 'url(#clip0_37938_279327)' },
        React.createElement("path", { d: 'M15.944 5.798a.32.32 0 0 0-.264-.245L11.4 4.9l.315-4.318a.32.32 0 0 0-.536-.258l-3.18 2.938L4.82.324a.32.32 0 0 0-.536.258L4.598 4.9l-4.28.653a.32.32 0 0 0-.132.58L3.758 8.58l-2.157 3.753a.32.32 0 0 0 .371.466l4.14-1.268 1.59 4.027a.32.32 0 0 0 .595 0l1.59-4.027 4.14 1.268a.32.32 0 0 0 .37-.466L12.24 8.58l3.572-2.447a.32.32 0 0 0 .132-.335', fill: 'url(#paint0_linear_37938_279327)' })),
    React.createElement("defs", null,
        React.createElement("linearGradient", { id: 'paint0_linear_37938_279327', x1: 0.047, y1: 7.999, x2: 15.951, y2: 7.999, gradientUnits: 'userSpaceOnUse' },
            React.createElement("stop", { stopColor: '#FE8323' }),
            React.createElement("stop", { offset: 0.5, stopColor: '#FF3C68' }),
            React.createElement("stop", { offset: 0.75, stopColor: '#DC1EAF' }),
            React.createElement("stop", { offset: 1, stopColor: '#B300D7' })),
        React.createElement("clipPath", { id: 'clip0_37938_279327' },
            React.createElement("path", { fill: '#fff', d: 'M0 0h16v16H0z' }))))); };

export { AIStarListIcon as default };
//# sourceMappingURL=index.js.map
